import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export const igSlider = () => {
  if (document.querySelector(".js-ig-slider") === null) {
    return;
  }

  const slider = new Splide(".js-ig-slider", {
    pagination: false,
    arrows: false,
    fixedWidth: "25rem",
    fixedHeight: "32rem",
    type: "loop",
    gap: "1rem",
    drag: "free",
    speed: 1000,
    // wheel: true,
    // snap: false,
    // wheelMinThreshold: 1,
    // releaseWheel: true,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
    },
  }).mount({ AutoScroll });
};
